export const getCirclePath = (circle, maps) => {
  const numPts = 1000
  let path = []
  for (let i = 0; i < numPts; i++) {
    path.push(
      maps.geometry.spherical.computeOffset(
        circle.getCenter(),
        circle.getRadius(),
        (i * 360) / numPts,
      ),
    )
  }
  return path
}
